import { features } from '@/mocks/homeData';

export default function Features() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择豆花视频
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            我们致力于为用户打造极致的观影体验，用心做好每一个细节
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors">
                <i className={`${feature.icon} text-xl text-primary-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}